import store from "../store";
import { Message } from "element-ui";
const roleCheck = {
  // 按钮角色校验
  btn: function(btn_code) {
    let res = true;
    if (sessionStorage.getItem("roles") === "ROLE_ADMIN") {
      res = false;
    }
    const btnroles = store.getters.btnroles;
    const role_arr = btnroles.filter(item => item.code === btn_code);
    if (role_arr.length === 0) {
      res = true;
    } else {
      res = false;
    }

    // const userrole = sessionStorage.getItem("roles");
    // role_arr.forEach(item => {
    //   if (item.needrole === "through") {
    //     res = false;
    //   }
    //   if (userrole === item.needrole) {
    //     res = false;
    //   }
    // });

    if (res) {
      Message({
        dangerouslyUseHTMLString: true,
        message: "用户无权限",
        type: "error",
        duration: 5 * 1000,
        showClose: true
      });
    }
    return res;
  }
};
export default roleCheck;
